const CONTEXT_FILTER_PARAMS = new Set(['view', 'tab', 'source', 'idents']);

export function isActiveFilterValue(value: unknown): boolean {
  if (value === undefined || value === null || value === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
}

export function getActiveColumnFilters(filters: Array<{ name: string; value: unknown }> = []) {
  return filters.filter(f => !CONTEXT_FILTER_PARAMS.has(f.name) && isActiveFilterValue(f.value));
}

export function hasActiveColumnFilters(filters: Array<{ name: string; value: unknown }> = []): boolean {
  return getActiveColumnFilters(filters).length > 0;
}
